import { defineStore } from 'pinia';
import axios from '@/axios';
import { API_BASE_URL } from '@/apiConfig';

export const useDataStore = defineStore('dataStore', {
  state: () => ({
    data: {
      categories: [],
      products: [],
      feedbacks: [],
      jobsNeeds: [],
      projects: [],
      partenaires: [],
    },
    loading: false,
    error: null,
  }),

  actions: {
    async fetchData() {
      this.loading = true;
      this.error = null;
      try {
        const [
          categoriesResponse,
          productsResponse,
          feedbacksResponse,
          jobsNeedsResponse,
          projectsResponse,
          partenairesResponse,
        ] = await Promise.all([
          axios.get('/categories'),
          axios.get('/products'),
          axios.get('/feedbacks'),
          axios.get('/jobs-needs'),
          axios.get('/projects'),
          axios.get('/partenaires'),
        ]);
	this.data.products = productsResponse.data?.data?.products ?? productsResponse.data?.data ?? productsResponse.data ?? [];
	this.data.categories = categoriesResponse.data ?? [];
        this.data.feedbacks = feedbacksResponse.data ?? [];
        this.data.jobsNeeds = jobsNeedsResponse.data ?? [];
        this.data.projects = projectsResponse.data ?? [];
        this.data.partenaires = partenairesResponse.data ?? [];

      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },

    // ✅ Optional: Keep this for other pages
    async fetchProductsByCategory(categoryId) {
      this.loading = true;
      this.error = null;
      try {
        const response = await axios.get(`/products?category=${categoryId}`);
        this.data.products = response.data?.data ?? response.data ?? [];
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },

    async subscribeUser(email) {
      this.loading = true;
      this.error = null;
      try {
        const response = await axios.post(`${API_BASE_URL}/subscriptions`, { email });
        console.log('Subscribed with email:', response.data);
      } catch (error) {
        this.error = error.response ? error.response.data.message : 'Subscription failed';
        console.log(this.error);
      } finally {
        this.loading = false;
      }
    },

    async loginUser(credentials) {
      this.loading = true;
      this.error = null;
      try {
        const response = await axios.post(`${API_BASE_URL}/login`, credentials);
        this.token = response.data.token;
        this.user = response.data.user;
        localStorage.setItem('token', JSON.stringify(this.token));
        localStorage.setItem('user', JSON.stringify(this.user));
      } catch (error) {
        this.error = error.response ? error.response.data.message : 'Échec de la connexion';
        console.log(error.response);
      } finally {
        this.loading = false;
      }
    },

    async signupUser(userDetails) {
      this.loading = true;
      this.error = null;
      try {
        const response = await axios.post(`${API_BASE_URL}/register`, userDetails);
        this.token = response.data.token;
        this.user = response.data.user;
        localStorage.setItem('token', JSON.stringify(this.token));
        localStorage.setItem('user', JSON.stringify(this.user));
      } catch (error) {
        this.error = error.response ? error.response.data.message : 'Échec de l\'inscription';
        alert(this.error);
      } finally {
        this.loading = false;
      }
    },

    async submitJobApplication(formData) {
      this.loading = true;
      this.error = null;
      try {
        const token = JSON.parse(localStorage.getItem('token'));
        const response = await axios.post(`${API_BASE_URL}/recruitments`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
          },
        });
        return response.data;
      } catch (error) {
        this.error = error.response ? error.response.data.message : 'Submission failed';
        console.error('Error submitting job application:', error.response ?? error);
        throw error;
      } finally {
        this.loading = false;
      }
    },

    async submitGeneralApplication(formData) {
      this.loading = true;
      this.error = null;
      try {
        const token = JSON.parse(localStorage.getItem('token'));
        const response = await axios.post(`${API_BASE_URL}/recruitments`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
          },
        });
        return response.data;
      } catch (error) {
        this.error = error.response ? error.response.data.message : 'Submission failed';
        console.error('Error submitting general application:', error.response ?? error);
        throw error;
      } finally {
        this.loading = false;
      }
    },
  },
});

